interface ListeningBarProps {
  simulated: boolean;
  partial: string;
}

/**
 * Shown while the mic is on. When the platform recogniser is unavailable the
 * label says so plainly rather than passing scripted text off as heard speech.
 */
export function ListeningBar({ simulated, partial }: ListeningBarProps) {
  return (
    <div className="listening" role="status">
      <div className="mic-meter" aria-hidden="true">
        <span className="mic-bar" />
        <span className="mic-bar" />
        <span className="mic-bar" />
      </div>
      <div className="listening-copy">
        <p className="listening-label">
          {simulated ? 'Listening · simulated dictation' : 'Listening · spoken English in'}
        </p>
        <p className="listening-partial" aria-live="off">
          {partial || '…'}
        </p>
      </div>
    </div>
  );
}
